import { PortalTelemetryScreen } from '../../../app/telemetry/portalTelemetryScreens';
import { portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../app/telemetry/usePortalTelemetry';
import { Box, Paper, Grid, Typography } from "@mui/material";
import BackToRequests from "../BackToRequests";

interface Props {
    message: React.ReactNode;
}

export default function SuccessResponse(props: Props) {
    usePortalScreen(portalScreenContext(PortalTelemetryScreen.SuccessResponse), undefined, true);

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>
            <Grid container rowSpacing={4} sx={{ ml: '2%', mt: '0%', width: '96%' }}>

                <Grid size={{ xs: 12 }}></Grid>
                
                <Grid size={{ xs: 12 }}>
                    <BackToRequests />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Typography gutterBottom variant="h5" component="span">
                        {props.message}
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}